// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3o2JE","label":"styles_label__3C14q"};